export default __webpack_public_path__ + "static/media/arrow-view.94a2a7ab.svg";